import { useEffect } from 'react';
import { useFormContext } from 'react-hook-form';
import { getCachedValue, setCachedValue } from '../lib/valueCache';

type ReloadValueOptions = {
  shouldTouch?: boolean;
};

export function useReloadValue(name: string, options?: ReloadValueOptions) {
  const {
    setValue,
    getValues,
    formState: { dirtyFields },
  } = useFormContext();
  const value = getValues(name);
  const hasValue = value !== undefined && value !== null && value !== '';

  const isDirty = dirtyFields[name];

  if (hasValue && isDirty) {
    setCachedValue(name, value);
  }

  useEffect(() => {
    // Upon form reload all values are added to the cache, and reloaded into the form here
    const cachedValue = getCachedValue(name);
    const hasValue =
      cachedValue !== undefined && cachedValue !== null && cachedValue !== '';

    if (hasValue && !isDirty) {
      setValue(name, cachedValue, {
        shouldDirty: true,
        shouldTouch: options?.shouldTouch,
      });
    }
  }, []);
}
